module.exports = __webpack_public_path__ + "img/2.8e0cb81.png";